/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI Document on Azure Functions
 * This is the OpenAPI Document on Azure Functions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SupplierBranch
 */
export interface SupplierBranch {
    /**
     * 
     * @type {string}
     * @memberof SupplierBranch
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof SupplierBranch
     */
    clientReference?: string;
    /**
     * 
     * @type {string}
     * @memberof SupplierBranch
     */
    fullName?: string;
    /**
     * 
     * @type {string}
     * @memberof SupplierBranch
     */
    abbreviatedName?: string;
    /**
     * 
     * @type {string}
     * @memberof SupplierBranch
     */
    branchFullName?: string;
    /**
     * 
     * @type {string}
     * @memberof SupplierBranch
     */
    branchAbbreviatedName?: string;
    /**
     * 
     * @type {string}
     * @memberof SupplierBranch
     */
    reliability?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SupplierBranch
     */
    isActive?: boolean;
}

/**
 * Check if a given object implements the SupplierBranch interface.
 */
export function instanceOfSupplierBranch(value: object): value is SupplierBranch {
    return true;
}

export function SupplierBranchFromJSON(json: any): SupplierBranch {
    return SupplierBranchFromJSONTyped(json, false);
}

export function SupplierBranchFromJSONTyped(json: any, ignoreDiscriminator: boolean): SupplierBranch {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'clientReference': json['clientReference'] == null ? undefined : json['clientReference'],
        'fullName': json['fullName'] == null ? undefined : json['fullName'],
        'abbreviatedName': json['abbreviatedName'] == null ? undefined : json['abbreviatedName'],
        'branchFullName': json['branchFullName'] == null ? undefined : json['branchFullName'],
        'branchAbbreviatedName': json['branchAbbreviatedName'] == null ? undefined : json['branchAbbreviatedName'],
        'reliability': json['reliability'] == null ? undefined : json['reliability'],
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
    };
}

export function SupplierBranchToJSON(value?: SupplierBranch | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'clientReference': value['clientReference'],
        'fullName': value['fullName'],
        'abbreviatedName': value['abbreviatedName'],
        'branchFullName': value['branchFullName'],
        'branchAbbreviatedName': value['branchAbbreviatedName'],
        'reliability': value['reliability'],
        'isActive': value['isActive'],
    };
}

